export default "__VITE_ASSET__CymB$VgD__"